import { render, staticRenderFns } from "./OpeningTimesModal.vue?vue&type=template&id=60622fb2"
import script from "./OpeningTimesModal.vue?vue&type=script&lang=js"
export * from "./OpeningTimesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports